// 图形宽高超过此限度则在生成图片时禁掉滤镜，因为滤镜会造成超大gl buffer
export const FILTER_OVER_LIMIT = 800;

/**
 * 判断该图形是否需要禁止滤镜
 * @param isImageCopying 当前处于生成图片中
 * @param componentWidth 图形的宽度
 * @param componentHeight 图形的高度
 */
export const isCopyToImageOverSize = (isImageCopying?: boolean, componentWidth?: number, componentHeight?: number) => {
    if (!isImageCopying) {
        return false;
    }
    const thisComponentSize = Math.max(componentWidth || 0, componentHeight || 0);
    if (thisComponentSize > FILTER_OVER_LIMIT) {
        // 全局设置了禁止滤镜状态，且图形的宽高超过限度
        if (window) {
            window.maxComponentSize = Math.max(window.maxComponentSize || 0, thisComponentSize);
        }
        return true;
    }
    return false;
};
